import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { fidelityMaximizerModuleActions } from './FidelityMaximizerSagas'
import {
  selectConfig,
  selectContactConfig,
  selectFidelityMaximizerState,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useFidelityMaximizerEligibility from './useFidelityMaximizerEligibility'
import useFidelityMaximizerRealtimeSync from './useFidelityMaximizerRealtimeSync'

const CHECKLIST_KEYS = ['nlbp_classic', 'nlbp_personalized', 'myselectra', 'app_downloaded']

const useFidelityMaximizerSidebar = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { contactId } = useSelector(selectConfig)
  const { contractLoaded } = useSelector(selectContactConfig)
  const { loading, loaded, enabled, checklist } = useSelector(selectFidelityMaximizerState)

  const isEligibleAgent = useFidelityMaximizerEligibility()

  useFidelityMaximizerRealtimeSync(contactId, isEligibleAgent)

  useEffect(() => {
    if (!contractLoaded || !contactId || !isEligibleAgent || loaded || loading) {
      return
    }

    dispatch({ type: fidelityMaximizerModuleActions.FIDELITY_MAXIMIZER_LOAD_STATUS, contactId })
  }, [contractLoaded, contactId, isEligibleAgent, loaded, loading])

  const items = CHECKLIST_KEYS.map(key => ({
    key,
    done: checklist?.[key] === true,
  }))

  const currentValue = items.filter(item => item.done).length
  const maxValue = CHECKLIST_KEYS.length
  const isMastered = currentValue === maxValue
  const percentDone = maxValue > 0 ? (currentValue / maxValue) * 100 : 0

  return {
    t,
    hidden: !isEligibleAgent || !loaded || !enabled,
    items,
    currentValue,
    maxValue,
    isMastered,
    percentDone,
  }
}

export default useFidelityMaximizerSidebar
